import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { useState } from "react";

export const PricingSection = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubscribe = async () => {
    try {
      setIsLoading(true);
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) {
        navigate('/login');
        return;
      }

      const { data, error } = await supabase.functions.invoke('create-checkout');
      if (error) throw error;

      if (data?.url) {
        window.location.href = data.url;
      }
    } catch (error) {
      console.error('Error creating checkout session:', error);
      toast({
        title: "Error",
        description: "Could not start checkout process",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="py-12 md:py-16 bg-primary/5">
      <div className="container mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold mb-8">Simple, Transparent Pricing</h2>
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Free Plan */}
          <Card className="p-6 md:p-8 flex flex-col justify-between">
            <div>
              <h3 className="text-xl font-semibold mb-2">Free Plan</h3>
              <p className="text-2xl font-bold mb-4">$0</p>
              <ul className="text-left space-y-3 mb-6">
                <li className="flex items-center">
                  <Check className="mr-2 h-5 w-5 text-primary" />
                  Basic DBT chat support
                </li>
                <li className="flex items-center">
                  <Check className="mr-2 h-5 w-5 text-primary" />
                  Daily mood tracking
                </li>
                <li className="flex items-center">
                  <Check className="mr-2 h-5 w-5 text-primary" />
                  Simple safety plan
                </li>
              </ul>
            </div>
            <Button variant="outline" className="w-full" onClick={() => navigate('/login')}>
              Get Started
            </Button>
          </Card>

          {/* Premium Plan */}
          <Card className="p-6 md:p-8 flex flex-col justify-between border-primary">
            <div>
              <h3 className="text-xl font-semibold mb-2">Premium Plan</h3>
              <p className="text-2xl font-bold mb-4">$9.99/month</p>
              <ul className="text-left space-y-3 mb-6">
                <li className="flex items-center">
                  <Check className="mr-2 h-5 w-5 text-primary" />
                  Unlimited DBT chat conversations
                </li>
                <li className="flex items-center">
                  <Check className="mr-2 h-5 w-5 text-primary" />
                  Advanced DBT techniques
                </li>
                <li className="flex items-center">
                  <Check className="mr-2 h-5 w-5 text-primary" />
                  Comprehensive progress tracking
                </li>
                <li className="flex items-center">
                  <Check className="mr-2 h-5 w-5 text-primary" />
                  Priority support
                </li>
                <li className="flex items-center text-primary font-medium">
                  <Check className="mr-2 h-5 w-5 text-primary" />
                  All profits donated to BPD research
                </li>
              </ul>
            </div>
            <Button 
              className="w-full" 
              onClick={handleSubscribe}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Subscribe Now"}
            </Button>
          </Card>
        </div>
      </div>
    </section>
  );
};